<template>
  <b-modal
    centered
    :hide-footer="true"
    modal-class="c-wrap"
    dialog-class="c-dialog"
    content-class="c-content2"    
    header-class="popup_header1"
    body-class="c-body container"
    :visible="visible"
    @hide="hide"

  >
    <template #modal-header="{ close }">
      <span style="margin: auto">{{$t('more.set_my_info')}}</span>
      <b-img class="mo_close_btn"  @click="hide" :src="require('../../../assets/image/ic_close2.png')"/>
    </template>
    <div class="wrapper">
      <div class="card_wrapper" >
        <template v-if="photo == ''">
          <div class="card_label">{{$t('signup_info.business_card_photo')}}</div>
          <b-button @click="onCard" class="card_btn card_btn_label">{{$t('signup_info.bs_regist')}}</b-button>
          <div class="card_guide">{{$t('signup_info.photo_guide')}}</div>
        </template>
        <template v-else>
          <b-img @click="onCard" :src="photo" style="width: 100%; height: 100%;"/>
        </template>
      </div>
      <input @change="onImageChange" type="file" name="file" accept="image/*" ref="img-file" style="display: none" />
      <b-input v-model="affiliation"
               :placeholder="$t('signup_info.affiliation_placeholder')"
               class="input_wrapper "
               style="margin-top: 66px;"/>
      <b-input v-model="name"
               :placeholder="$t('signup_info.name_placeholder')"
               class="input_wrapper "
               style="margin-top: 48px;"/>
      <b-button @click="onModify" class="signup_btn" style="width: 100%; margin: 7em 0 0 0;">
        {{$t('common.modify')}}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import moment from "moment";
import Utils from "../../../config/utils";
const u = require('util');

export default {
  name: "SetMyInfoPopup",
  components:{
  },
  props:{
    visible:{
      type:Boolean,
      default:false,
    },
  },
  data() {
    return {
      affiliation:'',
      name:'',
      photo:'',
    }
  },
  methods:{

    hide(){
      this.$emit('update:visible', false);
    },

    onModify(){
      if (this.affiliation == '') {
        Utils.toast(this, this.$t('signup_info.affiliation_placeholder'));

        return;
      }
      if (this.name == '') {
        Utils.toast(this, this.$t('signup_info.name_placeholder'));
        return;
      }

      Utils.requestPost(
        this.$c.API.User.updateProfile,
        {
          business_card: this.photo,
          affiliation: this.affiliation,
          name: this.name
        },
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
          this.iSync();
          this.hide();          
          Utils.toast(this, this.$t('common.save_success'));
        } else {
          Utils.toast(this, result.msg);
        }
      });
    },
    sync(){
      this.affiliation = this.myinfo.affiliation;
      this.name = this.myinfo.name;
      this.photo = this.myinfo.businessCard;
    },
    iSync(){
      this.myinfo.affiliation = this.affiliation;
      this.myinfo.name = this.name;
      this.myinfo.businessCard = this.photo;
      this.myinfo.saveInfo();
    },
    onCard(){
      this.$refs["img-file"].click();
    },
    onImageChange(){
      let file = this.$refs['img-file'].files[0];
      Utils.requestUpload(
        this,
        this.$c.API.Upload.image,
        file,
        '2'
      ).then(result => {
        if (result.code === this.$c.API_RES_CODE.SUCCESS) {
              this.photo = result.data.url;
        } else {
          Utils.toast(this,result.msg);
        }
      });

    },

  },
  computed:{
  },
  watch:{
    visible(){
      this.sync();
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/vars";
@import "../../../assets/css/auth/SignupInfo";
.wrapper{margin:20px $content_margin; display: flex; flex-direction: column; align-items: center};
.input_wrapper{height: 50px; border:0; border-radius: 0; border-bottom:solid 0.5px #4e4e4e; padding:20px 24px; text-align: center; margin-top: 48px; width:80%; font-size: $fs_22; font-family: $korean_gd_14_r;};
.input{color: $text; font-size: $fs_22; font-family: $korean_gd_14_r;};
::placeholder{
  color:$c_a6a6a6;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/SetMyInfoPopup.vue